export function ScanDao(XRAY_RESOURCE, XRayUIDaoFactory) {
  return XRayUIDaoFactory()
    .setCustomActions({
      'startScan': {
        path: XRAY_RESOURCE.SCAN,
        method: 'POST',
        notifications: false
      },
      'historyScan': {
        path: XRAY_RESOURCE.HISTORY_SCAN,
        method: 'POST',
        notifications: true
      }
    })
    .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/scan_dao.js